import { useTranslation } from 'react-i18next'
import { Button, SIZE } from 'baseui/button'
import usePceSearchV2 from './usePceSearchV2'
import useRetrievePCEsV2 from './useRetrievePCEsV2'
import SearchResultsModal from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/SearchResultsModal'
import SearchResultsTable from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/SearchResultsTable'
import useMeterSearchStyles from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useMeterSearchStyles'
import useSearchResultsPagination from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useSearchResultsPagination'

const PceSearchResults = () => {
  const { t } = useTranslation()
  const { chooseButtonKind, chooseButtonOverrides } = useMeterSearchStyles()

  const { searchPodResponses, handlePageChange, page, handleSelectPce, handleBackToSearch } = usePceSearchV2()
  const { errorMessage } = useRetrievePCEsV2()

  const resultsPerPage = 8
  const currentPage = page
  const { totalPages, paginatedResults } = useSearchResultsPagination(searchPodResponses, resultsPerPage, currentPage)

  const columns = [
    t('subscriptionTools:pce_search.result_table_head.row_pce'),
    t('subscriptionTools:pce_search.result_table_head.row_address_name'),
    t('subscriptionTools:pce_search.result_table_head.row_final_client'),
    t('subscriptionTools:pce_search.result_table_head.row_choose'),
  ]

  const tableData = paginatedResults.map(item => {
    return [
      item.pce || item.pod_id || '-',
      `${item.address || ''} ${item.city || ''}`.trim() || '-',
      item.occupant || '-',
      <Button
        key='choose'
        size={SIZE.mini}
        kind={chooseButtonKind}
        overrides={chooseButtonOverrides}
        onClick={() => handleSelectPce(item)}
      >
        {t('subscriptionTools:pce_search.result_table_head.row_choose')}
      </Button>,
    ]
  })

  if (errorMessage) {
    return (
      <SearchResultsModal
        title={t('subscriptionTools:pce_search.results_error.error_text')}
        message={errorMessage}
        isError={true}
        onBackToSearch={handleBackToSearch}
        backButtonText={t('subscriptionTools:pce_search.modify_search')}
      />
    )
  }

  if (!searchPodResponses.length) {
    return (
      <SearchResultsModal
        title={t('subscriptionTools:pce_search.no_results')}
        message={t('subscriptionTools:pce_search.modify_search')}
        onBackToSearch={handleBackToSearch}
        backButtonText={t('subscriptionTools:pce_search.modify_search')}
      />
    )
  }

  return (
    <SearchResultsTable
      columns={columns}
      data={tableData}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      onBackToSearch={handleBackToSearch}
      backButtonText={t('subscriptionTools:pce_search.modify_search')}
      t={t}
      translationPrefix='subscriptionTools:pce_search'
    />
  )
}

export default PceSearchResults
